export interface GetReturnBorrowCollectionRequest {
  collectionId: number
  collectionNo: string
}

export function GetReturnBorrowCollectionRequestToJSON(
  value: GetReturnBorrowCollectionRequest
): any {
  return {
    collection_id: value.collectionId !== 0 ? value.collectionId : undefined,
    collection_no: value.collectionNo !== '' ? value.collectionNo : undefined
  }
}
